import {
  types,
  IPutCredentialsAction,
  ILogoutAction,
  IFailure,
  IAuth,
} from '../types/auth'

export const putCredentials = (credentials: IAuth): IPutCredentialsAction => ({
  type: types.PUT_CREDENTIALS,
  credentials,
})

export const logout = (): ILogoutAction => ({
  type: types.LOGOUT,
})

export const authFailure = (message: string): IFailure => ({
  type: types.AUTH_FAILURE,
  message,
})
